import { colors, Table } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const TableWrapperStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 1rem;
  margin-bottom: 5rem;
  padding-bottom: 1rem;
  overflow: hidden;
  box-shadow: ${boxShadows.dark[2]};
`;

export const InfoWrapperStyled = styled.div`
  display: flex;
  margin-bottom: 5rem;
  align-items: flex-end;
  justify-content: center;
`;

export const TableStyled = styled(Table)`
  width: max(100%, 128rem);
`;
